import { get, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const getFinancedOffers = (documentId, siteId) =>
  get(`${url}/leasingfolders/${documentId}/${siteId}/folderfinancedoffers`);

const getFolderOfferPartners = (documentId, siteId) =>
  get(`${url}/leasingfolders/${documentId}/${siteId}/folder-offer-partners`);

const getClientOffers = clientId => get(`${url}/leasingfolders/clientoffers?clientId=${clientId}`);

const updateFinancedOffersOnFolder = (documentId, siteId, isRemoveOffersMode, financedOffers) =>
  post(`${url}/leasingfolders/${documentId}/${siteId}/updatefinancedoffers`, {
    documentId,
    siteId,
    isRemoveOffersMode,
    financedOffers
  });

const blockFacilitySublimitAmountManually = (documentId, siteId, documentTypeCode) =>
  post(`${url}/leasingfacilities/${documentId}/${siteId}/block-facility-sublimit-amount-manually`, {
    documentId,
    siteId,
    documentTypeCode
  });

const exp = {
  getFinancedOffers,
  getClientOffers,
  getFolderOfferPartners,
  updateFinancedOffersOnFolder,
  blockFacilitySublimitAmountManually
};
export default exp;
